import { useState, useEffect, useCallback } from 'react';
import { CURRENCIES, FALLBACK_CURRENCY } from '../utils/pricing';
import { CHIAVE_SCELTA, sceltaSalvata, rilevaValuta } from '../utils/valuta';

// La rilevazione e la chiave vivono in utils/valuta.js: undici componenti
// chiamano questo hook e prima ognuno faceva la sua richiesta (2026-09-12).
const STORAGE_KEY = CHIAVE_SCELTA;
const readOverride = sceltaSalvata;

// Server-side geo-IP currency detection (CF-IPCountry header or geoip-lite
// fallback — see backend/routes/geo.js), with a manual override the user can
// set as a fallback if the detection gets it wrong. The override persists in
// localStorage so it applies consistently across the whole site, including
// at checkout time.
export function useCurrency() {
  const [currency, setCurrencyState] = useState(() => readOverride() || FALLBACK_CURRENCY);
  const [detected, setDetected] = useState(null);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    let cancelled = false;
    const hasOverride = !!readOverride();
    // rilevaValuta() non rifiuta mai: in caso di errore restituisce il
    // ripiego, che e' quello che faceva il catch di prima.
    rilevaValuta().then((cur) => {
      if (cancelled) return;
      setDetected(cur);
      if (!hasOverride) setCurrencyState(cur);
      setLoading(false);
    });
    return () => { cancelled = true; };
  }, []);

  const setCurrency = useCallback((cur) => {
    if (!CURRENCIES.includes(cur)) return;
    setCurrencyState(cur);
    try { localStorage.setItem(STORAGE_KEY, cur); } catch {}
  }, []);

  const resetToDetected = useCallback(() => {
    try { localStorage.removeItem(STORAGE_KEY); } catch {}
    if (detected) setCurrencyState(detected);
  }, [detected]);

  return { currency, detected, loading, setCurrency, resetToDetected, isOverridden: !!readOverride() };
}
